<template>
  <section :id="$style.about_history_visual">
    <div :class="$style.detail">
      <span>幼くして野球に出会った松井秀喜は、さまざまな人に支えられ大好きな野球に自らの進むべき道を見出しました。</span>
      <br />
      <span>このミュージアムは、そんな彼の野球への熱い思いと何よりも野球を通して「夢」を追い続けることの大切さをテーマに創設しました。</span>
      <br />
      <span>館長 松井昌雄</span>
      <div>
        <a href="#" v-scroll-to="'#first'" :class="$style.btn_activeArea">
          <div class="animated bounce infinite" :class="$style.arrow"></div>
        </a>
      </div>
    </div>

    <div :class="[$style.first_area, $style.area]">
      <main-title
        v-observe-visibility="visibilityChanged_btn1"
        :class="{[$style.main_title]: true, ['animated fadeIn']:isVisible_btn1}"
        :main_title="'1. 松井秀喜と野球'"
        :sub_title="'〜 父とのキャッチボール・兄と友達と三角ベース野球 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="{[$style.caption]: true, ['animated fadeIn']: isVisible_btn1}">
        松井秀喜がこの地に生を受けたのは、1974年6月12日のことであります。
        幼くして野球と出会った松井秀喜は、その後さまざまな人に支えられ、
        幸いにもその大好きな野球に自らの進むべき道を見出し、今も邁進いたしております。
      </div>
      <div :class="[$style.fig1, $style.fig]"></div>
      <div id="first"></div>
    </div>

    <div :class="[$style.second_area, $style.area]">
      <main-title
        v-observe-visibility="visibilityChanged_btn2"
        :class="{[$style.main_title]: true, ['animated fadeIn']:isVisible_btn2}"
        :main_title="'2. 夢の始まり'"
        :sub_title="'〜 少年野球・中学野球 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="{[$style.caption]: true, ['animated fadeIn']: isVisible_btn2}">
        このトスマシーンは、松井選手が小学校6年生の時、お父さんに買ってもらったものです。
        当時、根上少年野球クラブの主将だった松井少年は野球の練習が終わり帰宅すると、さらにこのマシーンで打ち込みに励みました。
        いつも自分が納得できるまで練習を続けた松井選手にとって、このマシーンは良きパートナーでもあったのです。
      </div>
      <div :class="[$style.fig2, $style.fig]"></div>
    </div>

    <div :class="[$style.third_area, $style.area]">
      <main-title
        v-observe-visibility="visibilityChanged_btn3"
        :class="{[$style.main_title]: true, ['animated fadeIn']:isVisible_btn3}"
        :main_title="'3. 甲子園に描いた夢'"
        :sub_title="'〜 高校野球・夢へのアーチ 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="{[$style.caption]: true, ['animated fadeIn']: isVisible_btn3}">
        星稜高校で野球に打ち込んだ日々は、松井選手にとって、野球そのものを見据えていく大切な時間でした。
        そして、その大きな軸であり支えであったのが、甲子園の名将と言われた山下智茂監督です。
        山下監督は松井選手を大きく育てたいと考え、最初から型にはめるのでなく、過程の中でアドバイスするといった方法で指導し、
        数々の壁を自らの力で打ち破っていった松井選手を「努力の天才」と呼びます。
      </div>
      <div :class="[$style.fig3, $style.fig]"></div>
    </div>

    <div :class="[$style.fourth_area, $style.area]">
      <main-title
        v-observe-visibility="visibilityChanged_btn4"
        :class="{[$style.main_title]: true, ['animated fadeIn']:isVisible_btn4}"
        :main_title="'4. 夢への挑戦（栄光の巨人へ）'"
        :sub_title="'〜 僕は不器用だから、人一倍練習してやっと追いつける 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div
        :class="{[$style.caption]: true, ['animated fadeIn']: isVisible_btn4}"
      >野球というスポーツの素晴らしさを子供たちに伝えたい。そのためにも、ホームランを打ちたい。</div>
      <div :class="[$style.fig4, $style.fig]"></div>
    </div>

    <div :class="[$style.fifth_area, $style.area]">
      <main-title
        v-observe-visibility="visibilityChanged_btn5"
        :class="{[$style.main_title]: true, ['animated fadeIn']:isVisible_btn5}"
        :main_title="'5. 新たな夢を求め'"
        :sub_title="'〜 メジャーリーグへ 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div
        :class="{[$style.caption]: true, ['animated fadeIn']: isVisible_btn5}"
      >52,000人のファンがスタンディングオベーションで迎えてくれた。歓声がこだまし、拍手は鳴り止まなかった。</div>
      <div :class="[$style.fig5, $style.fig]"></div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "AboutHistoryVisual",

  components: {
    MainTitle
  },
  data() {
    return {
      isVisible_btn1: Boolean,
      isVisible_btn2: Boolean,
      isVisible_btn3: Boolean,
      isVisible_btn4: Boolean,
      isVisible_btn5: Boolean
    };
  },
  methods: {
    visibilityChanged_btn1(isVisible) {
      this.isVisible_btn1 = isVisible;
    },
    visibilityChanged_btn2(isVisible) {
      this.isVisible_btn2 = isVisible;
    },
    visibilityChanged_btn3(isVisible) {
      this.isVisible_btn3 = isVisible;
    },
    visibilityChanged_btn4(isVisible) {
      this.isVisible_btn4 = isVisible;
    },
    visibilityChanged_btn5(isVisible) {
      this.isVisible_btn5 = isVisible;
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #about_history_visual {
    color: #fff;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .arrow {
      margin-top: 60px;
      width: 30px;
      height: 30px;
      border-style: solid;
      border-width: 24px 14px 0 14px;
      border-color: rgb(255, 255, 255) transparent transparent transparent;
    }
    .detail {
      width: 100%;
      text-align: center;
      height: 100vh;
      font-size: 16px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: column;
      padding: 0px 10px;
    }
    .area {
      height: 100vh;
      width: 300px;
      position: relative;
      margin-top: 25px;
      margin-bottom: 25px;

      .main_title {
        position: absolute;
        width: 100%;
        top: 200px;
        z-index: 99;
      }
      .caption {
        position: absolute;
        top: 460px;
        width: 100%;
        z-index: 99;
        font-size: 16px;
      }
      .fig {
        top: 230px;
        position: absolute;
        background-size: 300px 300px;
        background-repeat: no-repeat;
        height: 300px;
        width: 300px;
      }
    }
    @for $i from 1 through 5 {
      .fig#{$i} {
        background-image: url("../../../assets/img/history/L#{$i}.jpg");
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #about_history_visual {
    color: #fff;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .detail {
      width: 100%;
      text-align: center;
      height: 100vh;
      font-size: 25px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: column;
      span {
        width: 900px;
      }
      .btn_activeArea {
        height: 70px;
        display: flex;
        .arrow {
          margin-top: 60px;
          width: 30px;
          height: 30px;
          border-style: solid;
          border-width: 24px 14px 0 14px;
          border-color: rgb(255, 255, 255) transparent transparent transparent;
        }
      }
    }

    .second_area,
    .fourth_area {
      .main_title,
      .caption {
        right: 0px;
      }
      .fig {
        left: 0px;
      }
    }
    .area {
      height: 100vh;
      width: 900px;
      position: relative;
      .main_title {
        position: absolute;
        width: 55%;
        top: 250px;
        z-index: 99;
      }
      .caption {
        position: absolute;
        top: 380px;
        width: 55%;
        z-index: 99;
        font-size: 23px;
      }
      .fig {
        top: 160px;
        position: absolute;
        right: 0px;
        background-size: 500px 500px;
        background-repeat: no-repeat;
        height: 500px;
        width: 500px;
      }
    }
    @for $i from 1 through 5 {
      .fig#{$i} {
        background-image: url("../../../assets/img/history/L#{$i}.jpg");
      }
    }
  }
}
</style>